import { Observable } from 'rxjs';

export abstract class FeatureFlagsProvider<TFeatureFlagIds, TFeatureFlagsType, ConfigType = object> {
	public abstract isLoading$: Observable<boolean>;
	public abstract getFeatureFlag$(id: TFeatureFlagIds): Observable<boolean>;
	public abstract getDynamicConfig$(id: TFeatureFlagIds): Observable<TFeatureFlagsType>;
	public abstract getConfig(): ConfigType;
	public abstract setConfig$(config: ConfigType): Observable<void>;
	public abstract refreshCache(): Observable<void>;
}
